<template>
    <div id="mailbox-menu">
        <div class="content">
            <button class="new-email-button" @click="newEmail">
                <span class="new-email-title">{{ $t("mail.newMail") }}</span>
            </button>
            <div>
                <b-form-group :label="$t('mail.mailSelecting')" label-for="type-input" class="form-group-user">
                    <b-form-select
                        id="type-input"
                        v-model="selectedMailId"
                        :data-vv-as="$t('message.contentType')"
                        :name="$t('message.contentType')"
                        type="text"
                    >
                        <option :value="getUserMail._id" v-for="getUserMail in getUserMailList()">
                            {{ getUserMail.mail }}
                        </option>
                    </b-form-select>
                </b-form-group>
            </div>
            <div class="group">
                <span class="title"> {{ $t("mail.myMails") }} </span>
                <div class="material-icons" style="font-size: 16px; cursor: pointer" @click="integrationMail">
                    settings
                </div>
            </div>
            <div class="list">
                <div class="item" :class="[selectedMenu === 'My' && 'selected']" @click="change('My')">
                    <div class="material-icons" style="font-size: 24px">all_inbox</div>
                    <div class="metas">
                        <span class="title">{{ $t("mail.inbox") }}</span>
                    </div>
                </div>
                <div class="item" :class="[selectedMenu === 'Sent' && 'selected']" @click="change('Sent')">
                    <div class="material-icons" style="font-size: 24px">send</div>
                    <div class="metas">
                        <span class="title">{{ $t("mail.sent") }}</span>
                    </div>
                </div>
            </div>
            <hr class="divider" />
            <div class="group" v-if="departmentMails.length > 0">
                <span class="title"> {{ $t("mail.departmentMails") }} </span>
                <div class="material-icons" style="font-size: 16px">help</div>
            </div>
            <div class="representative-mails">
                <div class="list" v-for="departmentMail of departmentMails">
                    <div
                        class="item"
                        :class="[selectedDepartment === departmentMail.mail.mail && 'selected']"
                        @click="changeSelectedDepartment(departmentMail.mail.mail)"
                    >
                        <div class="material-icons" style="font-size: 24px">person</div>
                        <div class="metas">
                            <span>
                                <span class="title">{{ getName(departmentMail.mail) }}</span>
                                <a-tooltip :title="departmentMail.mail.mail">
                                    <span class="subtitle department-mail">{{ departmentMail.mail.mail }}</span>
                                </a-tooltip>
                            </span>
                            <span class="unread-count" v-if="departmentMail.count > 0">{{ departmentMail.count }}</span>
                        </div>
                    </div>
                    <hr class="divider" />
                </div>
            </div>
            <div class="group" v-if="isVisible()">
                <span class="title"> Representative Mails </span>
                <div class="material-icons" style="font-size: 16px">help</div>
            </div>
            <div class="representative-mails" v-if="!!isAgentMailVisible">
                <div
                    class="list"
                    v-for="visibilityMail of visibilityMails"
                    @click="getRepresentativeMail(visibilityMail)"
                >
                    <div class="item" :class="[selectedRepresentative === visibilityMail._id && 'selected']">
                        <div class="material-icons" style="font-size: 24px">person</div>
                        <div class="metas">
                            <span class="title">{{ getNameFix(visibilityMail.user) }}</span>
                            <a-tooltip :title="visibilityMail.mail">
                                <span class="subtitle department-mail">{{ getNameFix(visibilityMail.mail) }}</span>
                            </a-tooltip>
                        </div>
                    </div>
                    <hr class="divider" />
                </div>
            </div>
            <!--        <div class="group">-->
            <!--            <span class="title"> INCOMING Attachment </span>-->
            <!--            <div class="material-icons" style="font-size: 16px">help</div>-->
            <!--        </div>-->
            <!--        <div class="list">-->
            <!--            <div class="item" :class="[selectedMenu === 'Company' && 'selected']" @click="change('Company')">-->
            <!--                <div class="material-icons" style="font-size: 24px">work</div>-->
            <!--                <div class="metas">-->
            <!--                    <span class="title">Company Inbox</span>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--        </div>-->
        </div>
        <button class="new-template-button" @click="newTemplate" v-if="false">
            <span class="new-template-title">{{ $t("mail.newTemplate") }}</span>
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import Representative from "../../../components/svg/Representative.vue";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";

const log = log2("MailboxMenu");
export default {
    name: "MailboxMenu",
    components: { Representative },
    props: {},
    data() {
        return {
            selectedMenuItem: "",
            visibilityMails: [],
            selectedMailId: "",
            selectedRepresentative: "",
            isAgentMailVisible: true,
            departmentMails: [],
        };
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        ...mapState({
            selectedMenu: (state) => state.mail.selectedMenu,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            selectedDepartment: (state) => state.mail.selectedDepartment,
            user: (state) => state.auth.user,
            selectedMailIdLocalStorage: (state) => state.mail.selectedMailId,
            allUnreadMailCounts: (state) => state.mail.allUnreadMailCounts,
        }),
        isMailCreatePermission() {
            return this.checkPermission(PERMISSION_TYPES["mail.create"].tr.name);
        },
    },
    methods: {
        ...mapActions({
            getDepartmentMailAndCount: "mail/getDepartmentMailAndCount",
            getVisibilityMailAddress: "mail/getVisibilityMailAddress",
            getAgentMailVisibility: "mail/getAgentMailVisibility",
        }),
        ...mapMutations({
            CHANGE_SELECTED_DEPARTMENT: "mail/CHANGE_SELECTED_DEPARTMENT",
            CHANGE_SELECTED_MENU: "mail/CHANGE_SELECTED_MENU",
            SELECTED_NEW_MAIL: "mail/SELECTED_NEW_MAIL",
            SELECTED_NEW_TEMPLATE: "mail/SELECTED_NEW_TEMPLATE",
            changeSelectedRepresentativeInfo: "mail/changeSelectedRepresentativeInfo",
            saveSelectedMailId: "mail/saveSelectedMailId",
        }),
        async getRepresentativeMail(selectedRepresentative) {
            console.log("selectedRepresentativeId userId...", selectedRepresentative);
            this.selectedRepresentative = selectedRepresentative._id;
            this.CHANGE_SELECTED_MENU("");
            this.CHANGE_SELECTED_DEPARTMENT("");
            this.changeSelectedRepresentativeInfo({
                userId: selectedRepresentative.user._id,
                mailAddress: selectedRepresentative.mail,
            });
        },
        getUserMailList() {
            console.log("getUserMailList allMailAddresses work..", this.allMailAddresses);
            return this.allMailAddresses.filter(
                (email) =>
                    (email.type === "user" && !!email.user && email.user._id === this.user._id) ||
                    email.visibility.users.includes(this.user._id)
            );
        },
        getNameFix(value) {
            if (!!value)
                return !!value.name && value.name.length > 20 ? value.name.substring(0, 20) + "..." : value.name;
            else return "";
        },
        isVisible() {
            return Object.keys(this.visibilityMails).length > 0 && !!this.isAgentMailVisible;
        },
        getUserMailAddress() {
            return !!this.allMailAddresses && this.allMailAddresses.length > 0
                ? this.allMailAddresses.filter(
                      (email) => email.type === "user" && !!email.user && email.user._id === this.user._id
                  )[0]?.mail
                : "";
        },
        newEmail() {
            if (!this.isMailCreatePermission) {
                this.$message.error(this.$t("noPermission"));
                return;
            } else {
                this.SELECTED_NEW_MAIL(true);
                this.$emit("mailDetail", []);
            }
        },
        newTemplate() {
            this.SELECTED_NEW_TEMPLATE(true);
        },
        change(val) {
            this.selectedRepresentative = "";
            this.CHANGE_SELECTED_MENU(val);
            this.CHANGE_SELECTED_DEPARTMENT("");
        },
        changeSelectedDepartment(val) {
            this.selectedRepresentative = "";
            this.CHANGE_SELECTED_MENU("department");
            this.CHANGE_SELECTED_DEPARTMENT(val);
        },
        integrationMail() {
            const userMailId = this.allMailAddresses.filter(
                (x) => !!x.user && x.user._id === this.user._id && !x.isSenderMail
            )[0]?._id;
            return this.$router.replace(`/integrations/mail/${userMailId}/user/detail`);
        },
        getName(departmentMailAddress) {
            console.log("departmentMailAddress work..", departmentMailAddress);
            if (!!departmentMailAddress.department) return departmentMailAddress.department.languageContent[0].name;
        },
    },
    async mounted() {
        console.log("mail box mounted work..", this.allMailAddresses);
        console.log("selectedMailIdLocalStorage..", this.selectedMailIdLocalStorage);

        await this.getAgentMailVisibility(this.user._id).then((res) => {
            this.isAgentMailVisible = res.agentMailVisibility;
        });

        // temsilciye ait default mail gelir yada userId değeri olmayan default seçili departman gelebilir
        if (!!this.selectedMailIdLocalStorage) {
            this.selectedMailId = this.selectedMailIdLocalStorage;
        } else {
            this.selectedMailId = this.allMailAddresses.filter(
                (email) =>
                    email.type === "user" &&
                    !!email.user &&
                    (email.user._id === this.user._id || !email.user._id) &&
                    !!email.idDefault
            )[0]?._id;
        }
        console.log("mail box mounted selectedMailId..", this.selectedMailId);

        this.departmentMails = await this.getDepartmentMailAndCount(this.user._id);
        console.log("this.departmentMails work..", this.departmentMails);

        this.visibilityMails = await this.getVisibilityMailAddress(this.user._id);
        console.log("this.visibilityMails work..", this.visibilityMails);
    },

    watch: {
        // maile tıklandığında, okunmuş okunmamış departman mail sayıların güncellenmesi için eklendi
        async allUnreadMailCounts() {
            if (this.selectedMenu === "department") {
                this.departmentMails = await this.getDepartmentMailAndCount(this.user._id);
            }
        },
        selectedMailIdLocalStorage(val) {
            console.log("---------watch selectedMailIdLocalStorage---------", this.selectedMailIdLocalStorage);
            if (!!val) {
                this.selectedMailId = val;
            }
        },
        selectedMailId(val) {
            console.log("---------watch selectedMailId---------", this.selectedMailId);
            this.saveSelectedMailId(val);
        },
        allMailAddresses(val) {
            console.log("---------watch allMailAddresses---------", this.allMailAddresses);
            if (this.selectedMailIdLocalStorage) {
                this.selectedMailId = this.selectedMailIdLocalStorage;
            } else {
                this.selectedMailId = this.allMailAddresses.filter(
                    (email) =>
                        email.type === "user" &&
                        !!email.user &&
                        (email.user._id === this.user._id || !email.user._id) &&
                        !!email.idDefault
                )[0]?._id;
            }
            console.log("---------selectedMailId---------", this.selectedMailId);
        },
    },
};
</script>

<style lang="scss">
#mailbox-menu {
    width: 268px;
    min-width: 268px;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 8px 8px 5px;
    border-right: 1px solid var(--color-border-default);
    gap: 5px;
    margin: 5px;
    justify-content: space-between;

    .form-group-user {
        margin-bottom: 1rem;
        width: 90%;
        margin-left: 15px;
        margin-top: 15px;
    }

    .content {
        .divider {
            border: none;
            height: 1px;
            margin: 0;
            flex-shrink: 0;
            background-color: rgba(0, 0, 0, 0.12);
        }

        .new-email-button {
            width: 100%;
            color: #fff;
            background-color: #009688;
            border-radius: 4px;
            padding: 6px 16px;
            border: none;
            box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                0px 1px 5px 0px rgba(0, 0, 0, 0.12);
            transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
                box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

            &:hover {
                background-color: rgb(0, 105, 95);
                box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
                    0px 1px 10px 0px rgba(0, 0, 0, 0.12);
            }

            .new-email-title {
                text-transform: uppercase;
            }
        }

        .department-mail {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 160px;
            display: flex;
        }

        .unread-count {
            background-color: #077907;
            color: white;
            padding: 3px;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;
        }

        .group {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                text-transform: uppercase;
                font-weight: 700;
                line-height: 24px;
            }
        }

        .representative-mails {
            overflow-x: hidden;
            max-height: 265px;
        }

        .list {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .item-menus {
                .item-menu {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    min-height: 36px;
                    font-weight: 600;
                    padding: 5px 5px 5px 20px;
                    margin: 0 8px;
                    border-radius: 8px;
                    cursor: pointer;
                    gap: 5px;

                    &.selected {
                        background: #e9f9ed;
                        border-left: 4px solid #b3d7bd;
                    }
                }
            }

            .item {
                display: flex;
                align-items: center;
                width: 100%;
                min-height: 36px;
                font-weight: 600;
                padding: 5px 5px 5px 8px;
                margin: 0 8px;
                border-radius: 8px;
                cursor: pointer;
                gap: 5px;

                &.selected {
                    background: #bfeadb;
                    border-left: 4px solid #009688;
                }

                .metas {
                    display: flex;
                    flex-direction: row;
                    grid-gap: 3px;
                    width: 80%;

                    .title {
                        line-height: 15px;
                        font-weight: 600;
                        color: black;
                    }

                    .subtitle {
                        line-height: 15px;
                        font-size: 12px;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .new-template-button {
        margin-bottom: 30px;
        height: 30px;
        color: #fff;
        background-color: #ec4a1d;
        border-radius: 4px;
        padding: 6px 16px;
        border: none;
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
            box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

        &:hover {
            background-color: #ec4a1d;
            box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14),
                0px 1px 10px 0px rgba(0, 0, 0, 0.12);
        }

        .new-template-title {
            text-transform: uppercase;
            font-weight: bold;
        }
    }
}
</style>
